<template>
  <div :class="layoutType" class="page-intro-header">
    <app-image
      v-if="image"
      :src="image"
      class="app-image"
      type="square"
      width="auto"
    />
    <video v-if="video" :src="video" class="app-video" controls></video>
    <div class="content">
      <div class="intro-header-title">{{ title }}</div>
      <div class="intro-header-description">{{ displayDescription }}</div>
      <div>
        <app-button
          v-if="button.link"
          :label="button.title"
          class="button-container"
          @click="navigate(button.link)"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { useContextStore } from '../../store/contextStore';

export default defineComponent({
  name: 'PageIntroHeaderHorizontal',
  props: {
    mirrorLayout: {
      type: Boolean,
      default: false
    },
    image: {
      type: String,
      default: ''
    },
    video: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: ''
    },
    button: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    displayDescription(): string {
      return this.description?.replaceAll(
        '{companyName}',
        useContextStore().organization!.name
      );
    },
    layoutType(): string {
      return this.mirrorLayout ? 'mirrored' : '';
    }
  },
  methods: {
    navigate(link: string) {
      window.location.href = link;
    }
  }
});
</script>

<style lang="scss" scoped>
.page-intro-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
  gap: 12px;
  text-align: center;

  &.mirrored {
    flex-direction: column-reverse;
  }
}

.app-video {
  height: 100%;
  max-width: 100%;
}

.app-image {
  max-width: 100%;
  height: 100%;
  min-height: 100px;
  max-height: 200px;
}

.content {
  flex-basis: 45%;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  height: 100%;

  .intro-header-title {
    font-weight: 600;
    font-size: 36px;
  }

  .intro-header-description {
    font-weight: 500;
    font-size: 15px;
    color: #999999;
  }
}

.button-container {
  margin-top: var(--space-4);
}

@media (max-width: 950px) {
  .content {
    flex-basis: 100%;
  }
}
</style>
